@use "variables" as *;

.itemTitle {
  font-size: $fontSize-m;
  font-weight: bold;
}

.listButton {
  padding-left: $spacing-l !important;
}
